<div class="grid grid-cols-2 gap-4">
  <div class="flex flex-row gap-3">
    <mat-slide-toggle
      [checked]="checked"
      [disabled]="disabledToggle"
      (change)="toggleChange.emit($event)"
    ></mat-slide-toggle>
    <div class="flex flex-col">
      <p class="text-[18px] font-normal">{{ title }}</p>
      <span class="setting-description">{{ description }}</span>
    </div>
  </div>
  <ng-container *ngIf="isShowPill">
    <app-pill
      *ngIf="isSubscriptionActive; else subscriptionNotActive"
      [type]="pillType.brandInverted"
      >{{ '+HEMS.SETTINGS.OPTIMIZATIONS.DYNAMIC_ASSISTANT_ON' | translate }}</app-pill
    >
  </ng-container>
</div>

<ng-template #subscriptionNotActive>
  <app-pill [type]="pillType.brand">{{
    '+HEMS.SETTINGS.OPTIMIZATIONS.DYNAMIC_ASSISTANT_REQUIRED' | translate
  }}</app-pill>
</ng-template>
